import React from 'react';
import './Contact.css';
import contactImage from '../../assets/contact-image.jpg';

const Contact: React.FC = () => {
  return (
    <section id="contact" className="contact-section section">
      <div className="contact-container">
        <div className="contact-image-container">
          <img src={contactImage} alt="JSW Team" className="contact-image" />
        </div>
        
        <div className="contact-info-container">
          <h2 className="contact-title">聯絡我們</h2>
          
          <div className="contact-info-list">
            <div className="contact-info-item">
              <div className="contact-icon email-icon"></div>
              <div className="contact-text">
                <h3>電郵</h3>
                <p>jaystreetworkout@gmail.com</p>
              </div>
            </div>
            
            <div className="contact-info-item">
              <div className="contact-icon phone-icon"></div>
              <div className="contact-text">
                <h3>電話</h3>
                <p>+852 6187 6217</p>
              </div>
            </div>
            
            <div className="contact-info-item">
              <div className="contact-icon location-icon"></div>
                <div className="contact-text">
                <h3>Studio 地址</h3>
                <p><a href="https://maps.app.goo.gl/g34CzWiRqk5LtNr3A" target="_blank" rel="noopener noreferrer" style={{color: 'white'}}>新蒲崗七寶街東傲</a></p>
                </div>
            </div>
          </div>
          
          <div className="social-media-container">
            <a href="https://www.instagram.com/_jaysw_/" target="_blank" rel="noopener noreferrer" className="social-icon instagram" aria-label="Follow us on Instagram">
              <span className="sr-only">Instagram</span>
            </a>
            <a href="https://wa.me/85261876217" target="_blank" rel="noopener noreferrer" className="social-icon whatsapp" aria-label="Contact us on WhatsApp">
              <span className="sr-only">WhatsApp</span>
            </a>
            <a href="https://www.facebook.com/jaystreetworkout?locale=zh_HK" target="_blank" rel="noopener noreferrer" className="social-icon facebook" aria-label="Visit our Facebook page">
              <span className="sr-only">Facebook</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
